<template>
  <div id="map" style="min-height: 600px" />
</template>
<script>
import { Loader } from "@googlemaps/js-api-loader";

export default {
  props: {
    apiKey: { type: String, required: true },
    center: { type: Object },
    markers: { type: Array },
    zoom: { type: Number, default: 10 },
    circles: { type: Array },
  },
  emits: ["buyer-hover", "buyer-hover-leave", "directions-rendered"],
  data() {
    return {
      map: null,
      loading: true,
      mapMarker: [],
      popups: [],
      directions: null,
      directionsRenderer: null,
      mapCircles: [],
      circleInstances: [],
    };
  },
  mounted() {
    this.loader = new Loader({
      apiKey: this.apiKey,
      version: "weekly",
    });
    this.loadMap();
  },
  methods: {
    loadMap() {
       
      this.loader.load().then(() => {
        this.directions = new google.maps.DirectionsService();
        this.directionsRenderer = new google.maps.DirectionsRenderer();
        this.map = new google.maps.Map(document.getElementById("map"), {
          center: this.center
            ? {
                lat: this.center.lat,
                lng: this.center.lng,
              }
            : new google.maps.LatLng(39.8283, -98.5795),
          zoom: this.center ? this.zoom : 4.5,
          mapTypeControl: false,
          scaleControl: false,
        });
        const that = this;
        this.map.addListener("click", function () {
          that.markers.forEach((marker) => {
            that.popups[marker.id].close();
          });
        });

        this.buildCircles();
        if (this.markers && this.markers.length > 0) {
          this.markers.map((marker, i) => {
            const icon = document.createElement("img");
            icon.src = marker.icon.url;
            icon.className = "custom-icon";
            this.mapMarker[marker.id] = new google.maps.Marker({
              position: marker.position,
              title: marker.title,
              animation: google.maps.Animation.DROP,
              content: icon,
            });

            if (marker.popupContent) {
              this.popups[marker.id] = new google.maps.InfoWindow({
                content: marker.popupContent,
              });

              this.mapMarker[marker.id].addListener("click", () => {
                this.markers.forEach((marker) => {
                  this.popups[marker.id].close();
                });

                this.popups[marker.id].open(this.map, this.mapMarker[marker.id]);
              });

              this.mapMarker[marker.id].addListener("mouseover", () => {
                this.$emit("buyer-hover", true);
              });

              this.mapMarker[marker.id].addListener("mouseout", () => {
                this.$emit("buyer-hover-leave", true);
              });
            }

            if (marker.icon) {
              this.mapMarker[marker.id].setIcon({
                url: marker.icon.url,
                scaledSize: new google.maps.Size(40, 40),
              });
            }

            this.mapMarker[marker.id].setMap(this.map);
          });
        }

        if (this.circles && this.circles.length > 0) {
          this.circles.forEach((circle, i) => {
            const circleInstance = new google.maps.Circle({
              strokeColor: circle.strokeColor,
              strokeOpacity: circle.strokeOpacity,
              strokeWeight: circle.strokeWeight,
              fillColor: circle.fillColor,
              fillOpacity: circle.fillOpacity,
              map: this.map,
              center: circle.center,
              radius: circle.radius,
            });

            this.circleInstances.push(circleInstance);
          });
        }

        if (this.map) {
          this.loading = false;
        }
      });

       
    },
    buildCircles() {
      const { map } = this;
      if (this.circles && this.circles.length > 0) {
        this.circles.forEach((circle) => {
          this.mapCircles.push({
            strokeColor: circle.strokeColor,
            strokeOpacity: circle.strokeOpacity,
            strokeWeight: circle.strokeWeight,
            fillColor: circle.fillColor,
            fillOpacity: circle.fillOpacity,
            map,
            center: circle.center,
            radius: circle.radius,
          });
        });
      }
    },
    getDirectionsRoute(origin, destination) {
      this.markers.map((marker, i) => this.mapMarker[marker.id].setMap(null));
      this.mapCircles.map((circle, i) => this.circleInstances[i].setMap(null));
      const request = {
        origin,
        destination,
        travelMode: "DRIVING",
      };
      const vm = this;

      this.directions.route(request, (response, status) => {
        if (status == "OK") {
          vm.directionsRenderer.setDirections(response);
          vm.directionsRenderer.setMap(vm.map);
          vm.directionsRenderer.setPanel(document.getElementById("directionsPanel"));
          vm.$emit("directions-rendered", true);
        }
      });
    },
    clearDirectionsRoute(locationId) {
      this.directionsRenderer.setMap(null);
      this.markers.map((marker, i) => this.mapMarker[marker.id].setMap(this.map));
      this.mapCircles.map((circle, i) => this.circleInstances[i].setMap(this.map));
      this.map.setZoom(this.zoom);
    },
    triggerBuyerPopupClick(locationId) {
      this.markers.forEach((marker) => {
        this.popups[marker.id].close();
      });

      this.popups[locationId].open(this.map, this.mapMarker[locationId]);
    },
    hidePopup(locationId) {
      this.popups[locationId].close();
    },
  },
};
</script>
